import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://fregvtiusgwmpodlvgfn.supabase.co'
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZyZWd2dGl1c2d3bXBvZGx2Z2ZuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAxNjE4ODMsImV4cCI6MjA4NTczNzg4M30.iNP0h6WzIiG02Z6WHHQHDfBwqICOLUl6-MdHY2bT6Aw'

export const supabase = createClient(supabaseUrl, supabaseKey)
